<template>
  <div class="student-report-empty-state">
    <student-illustration class="w-full"></student-illustration>
    <p class="title">{{ title }}</p>
    <p class="desc">{{ desc }}</p>
  </div>
</template>

<script>
import StudentIllustration from "@/components/Base/Illustration/Student.vue";

export default {
  components: { StudentIllustration },
  props: {
    title: {
      type: String,
      default: "No report data"
    },
    desc: {
      type: String,
      default: "Please do action to get report data"
    }
  },
  name: "std-report-empty-state"
};
</script>

<style lang="scss" scoped>
.student-report-empty-state {
  @apply flex flex-col justify-center items-center;
  @apply text-center;

  .title {
    @apply text-2xl font-medium;
  }

  .desc {
    @apply max-w-lg mt-2;
    @apply text-gray-500;
  }
}
</style>
